export default "__VITE_ASSET__5150ed72__"